import React, { useState, useEffect, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import AuthContext from "../auth/AuthContext";
import "../style/TopBar.css";

const TopBar = ({ onMenuToggle, isMenuOpen, isMobile, isSidebarCollapsed, onToggleCollapse }) => {
  const { auth, user } = useContext(AuthContext);
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    // Only hide on scroll for mobile
    if (!isMobile) {
      setIsVisible(true);
      return;
    }

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // Show bar when scrolling up, hide when scrolling down
      if (currentScrollY < lastScrollY || currentScrollY < 10) {
        setIsVisible(true);
      } else if (currentScrollY > lastScrollY && currentScrollY > 10) {
        setIsVisible(false);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY, isMobile]);

  const isProfileActive = location.pathname === "/profile";
  const isManagePlotsPage = location.pathname.includes("/plots") && !location.pathname.includes("/detail");
  
  // Hide TopBar completely when on ManageGardenPlots page (both mobile and desktop)
  if (isManagePlotsPage) {
    return null;
  }

  return (
    <header className={`top-bar ${isMobile ? (isVisible ? "top-bar-visible" : "top-bar-hidden") : "top-bar-desktop"} ${isSidebarCollapsed && !isMobile ? "sidebar-collapsed" : ""}`}>
      {/* Burger Menu Button - Mobile Only */}
      {isMobile && (
        <button
          className="burger-menu-button"
          onClick={onMenuToggle}
          aria-label="Toggle menu"
          aria-expanded={isMenuOpen}
        >
          <span className="burger-line"></span>
          <span className="burger-line"></span>
          <span className="burger-line"></span>
        </button>
      )}
      
      <div className="top-bar-title">
        <h1 className="top-bar-title-main">Agritur</h1>
        <div className="top-bar-title-sub">Gardening Guide</div>
      </div>
      
      {/* Collapse Toggle Button - Desktop Only */}
      {!isMobile && onToggleCollapse && (
        <button
          className="top-bar-collapse-toggle"
          onClick={onToggleCollapse}
          aria-label={isSidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
          aria-expanded={!isSidebarCollapsed}
        >
          <span className="burger-line"></span>
          <span className="burger-line"></span>
          <span className="burger-line"></span>
        </button>
      )}

      {/* Profile Icon - Right side */}
      {auth?.user && (
        <Link 
          to="/profile" 
          className={`top-bar-profile-icon ${isProfileActive ? "active" : ""}`}
          aria-label="Profile"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M20.59 22C20.59 18.13 16.74 15 12 15C7.26 15 3.41 18.13 3.41 22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </Link>
      )}
    </header>
  );
};

export default TopBar;

